import { render, staticRenderFns } from "./PodImages.vue?vue&type=template&id=1df8a06e&"
import script from "./PodImages.vue?vue&type=script&lang=js&"
export * from "./PodImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports